document.addEventListener('click',event=>{
  const t=event.target.closest('[data-scroll-to]');
  if(!t)return;
  const el=document.querySelector(t.getAttribute('data-scroll-to'));
  if(el)el.scrollIntoView({behavior:'smooth'});
});

document.addEventListener('click',event=>{
  const thumb=event.target.closest('[data-product-thumb]');
  if(!thumb)return;
  const gallery=thumb.closest('[data-product-gallery]');
  const main=gallery&&gallery.querySelector('[data-product-main-image]');
  const src=thumb.getAttribute('data-full-image');
  if(!main||!src)return;
  main.src=src;
  main.alt=thumb.getAttribute('data-alt')||main.alt;
  gallery.querySelectorAll('[data-product-thumb]').forEach(button=>button.classList.remove('is-active'));
  thumb.classList.add('is-active');
});

document.addEventListener('click',event=>{
  const back=event.target.closest('[data-back-link]');
  if(!back)return;
  if(window.history.length>1){
    event.preventDefault();
    window.history.back();
  }
});

document.addEventListener('change',event=>{
  const checkbox=event.target.closest('[data-checkout-policy-required]');
  if(!checkbox)return;
  const cartForm=checkbox.closest('form');
  const checkoutButton=cartForm&&cartForm.querySelector('[data-checkout-button]');
  const acknowledgement=checkbox.closest('.policy-acknowledgement');
  if(checkoutButton)checkoutButton.disabled=!checkbox.checked;
  if(acknowledgement&&checkbox.checked)acknowledgement.classList.remove('is-warning');
});

document.addEventListener('click',event=>{
  const checkoutButton=event.target.closest('[data-checkout-button]');
  if(!checkoutButton)return;
  const cartForm=checkoutButton.closest('form');
  const checkbox=cartForm&&cartForm.querySelector('[data-checkout-policy-required]');
  if(checkbox&&!checkbox.checked){
    event.preventDefault();
    const acknowledgement=checkbox.closest('.policy-acknowledgement');
    if(acknowledgement)acknowledgement.classList.add('is-warning');
  }
});

function initNeonHero(){
  const hero=document.querySelector('[data-neon-hero]');
  const canvas=hero&&hero.querySelector('[data-neon-hero-canvas]');
  if(!hero||!canvas||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const ctx=canvas.getContext('2d');
  const pointer={x:.5,y:.46,active:false};
  let width=0,height=0,particles=[],frameId=null;
  const resize=()=>{
    const rect=hero.getBoundingClientRect();
    const dpr=Math.min(window.devicePixelRatio||1,2);
    width=Math.max(1,Math.floor(rect.width));
    height=Math.max(1,Math.floor(rect.height));
    canvas.width=Math.floor(width*dpr);
    canvas.height=Math.floor(height*dpr);
    canvas.style.width=width+'px';
    canvas.style.height=height+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
    const count=Math.min(95,Math.max(45,Math.floor(width/18)));
    particles=Array.from({length:count},(_,index)=>({
      x:Math.random()*width,
      y:Math.random()*height,
      baseX:Math.random()*width,
      baseY:Math.random()*height,
      vx:(Math.random()-.5)*.28,
      vy:(Math.random()-.5)*.22,
      r:1.2+Math.random()*2.8,
      phase:Math.random()*Math.PI*2,
      side:index%2===0?'left':'right'
    }));
  };
  const move=event=>{
    const rect=hero.getBoundingClientRect();
    pointer.x=(event.clientX-rect.left)/rect.width;
    pointer.y=(event.clientY-rect.top)/rect.height;
    pointer.active=true;
    hero.style.setProperty('--hero-mouse-x',(pointer.x*100).toFixed(2)+'%');
    hero.style.setProperty('--hero-mouse-y',(pointer.y*100).toFixed(2)+'%');
  };
  const leave=()=>{pointer.active=false;};
  const draw=()=>{
    ctx.clearRect(0,0,width,height);
    const px=pointer.x*width;
    const py=pointer.y*height;
    const glow=ctx.createRadialGradient(px,py,0,px,py,Math.max(width,height)*.34);
    glow.addColorStop(0,'rgba(208,92,255,.28)');
    glow.addColorStop(.34,'rgba(156,53,255,.13)');
    glow.addColorStop(1,'rgba(156,53,255,0)');
    ctx.fillStyle=glow;
    ctx.fillRect(0,0,width,height);
    particles.forEach((p,index)=>{
      const edge=p.side==='left'?width*.12:width*.88;
      p.baseX+=p.vx;
      p.baseY+=p.vy;
      if(p.baseY<height*.08||p.baseY>height*.92)p.vy*=-1;
      if(p.side==='left'&&(p.baseX<0||p.baseX>width*.43))p.vx*=-1;
      if(p.side==='right'&&(p.baseX<width*.57||p.baseX>width))p.vx*=-1;
      const dx=p.baseX-px;
      const dy=p.baseY-py;
      const dist=Math.max(1,Math.hypot(dx,dy));
      const pull=pointer.active?Math.max(0,1-dist/340):0;
      const wave=Math.sin(Date.now()/850+p.phase)*9;
      p.x=p.baseX+(edge-p.baseX)*.012-(dx/dist)*pull*36;
      p.y=p.baseY+wave-(dy/dist)*pull*28;
      ctx.beginPath();
      ctx.fillStyle=index%5===0?'rgba(255,255,255,.72)':'rgba(208,92,255,.72)';
      ctx.shadowBlur=18+pull*18;
      ctx.shadowColor='rgba(208,92,255,.9)';
      ctx.arc(p.x,p.y,p.r+pull*1.8,0,Math.PI*2);
      ctx.fill();
      ctx.shadowBlur=0;
    });
    for(let i=0;i<particles.length;i+=1){
      for(let j=i+1;j<particles.length;j+=1){
        const a=particles[i],b=particles[j];
        const dist=Math.hypot(a.x-b.x,a.y-b.y);
        if(dist<95){
          ctx.strokeStyle=`rgba(208,92,255,${(1-dist/95)*.18})`;
          ctx.lineWidth=1;
          ctx.beginPath();
          ctx.moveTo(a.x,a.y);
          ctx.lineTo(b.x,b.y);
          ctx.stroke();
        }
      }
    }
    frameId=requestAnimationFrame(draw);
  };
  resize();
  hero.addEventListener('pointermove',move,{passive:true});
  hero.addEventListener('pointerleave',leave);
  window.addEventListener('resize',resize,{passive:true});
  frameId=requestAnimationFrame(draw);
  document.addEventListener('shopify:section:unload',()=>{if(frameId)cancelAnimationFrame(frameId);},{once:true});
}

document.addEventListener('DOMContentLoaded',initNeonHero);
